module.exports = __webpack_public_path__ + "static/hearing-2768b5d0cfc871e4b17fbc22cdf0700c.mp4";